export const email = {
  // Dashboard
  loadingModule: 'Loading email module...',
  welcomeToEmailModule: 'Welcome to the Email Module',
  connectAccountsToStart: 'Connect your email accounts to start managing your messages',
  connectFirstAccount: 'Connect first email account',
  whatCanYouDo: 'What can you do with the Email module?',
  manageMultipleAccounts: 'Manage multiple accounts',
  manageMultipleAccountsDesc: 'Connect Gmail, Outlook, Yahoo and custom providers',
  sendEmails: 'Send emails',
  sendEmailsDesc: 'Compose and send emails from any of your accounts',
  configureAndSync: 'Configure and synchronize',
  configureAndSyncDesc: 'Control synchronization and advanced settings',
  activeAccounts: 'Active accounts',
  unreadMessages: 'Unread messages',
  totalMessages: 'Total messages',
  inbox: 'Inbox',
  settings: 'Settings',
  configuration: 'Configuration',
  loadingMessages: 'Loading messages...',
  noMessages: 'You have no messages',
  noMessagesDesc: 'Your messages will appear here when synced',
  configureAccounts: 'Configure accounts',
  latestMessages: 'Latest messages',
  messagesSynced: '{count} messages synced',
  newBadge: 'New',
  unknownAccount: 'Unknown account',
  demoFunctionAlert: 'Demo function: This module simulates email sending. In a production environment, it would connect with real SMTP servers.',

  // Compose
  composeEmail: 'Compose Email',
  composeAndSend: 'Compose and send a new email from one of your configured accounts',
  noActiveAccounts: 'You have no active email accounts. Add an account first to send emails.',
  sendingData: 'Sending data',
  sendFrom: 'Send from',
  selectAccount: 'Select an account',
  recipients: 'To (recipients)',
  recipientPlaceholder: 'recipient@example.com',
  addRecipient: 'Add recipient',
  ccCopy: 'CC (copy)',
  ccPlaceholder: 'cc@example.com',
  addCC: 'Add CC',
  addBCC: 'Add BCC',
  bccHiddenCopy: 'BCC (hidden copy)',
  bccPlaceholder: 'bcc@example.com',
  messageContent: 'Message content',
  subject: 'Subject',
  subjectPlaceholder: 'Email subject',
  message: 'Message',
  messagePlaceholder: 'Write your message here...',
  cancel: 'Cancel',
  sending: 'Sending...',
  sendEmail: 'Send Email',

  // Settings
  generalSettings: 'General Settings',
  adjustGlobalSettings: 'Adjust global settings for the email module',
  synchronization: 'Synchronization',
  autoSync: 'Auto synchronization',
  syncInterval: 'Sync interval',
  minutes5: '5 minutes',
  minutes15: '15 minutes',
  minutes30: '30 minutes',
  hour1: '1 hour',
  hours2: '2 hours',
  maxMessages: 'Maximum messages per account',
  emailNotifications: 'Email notifications for new emails',
  syncing: 'Syncing...',
  syncAllAccounts: 'Sync all accounts',
  emailAccounts: 'Email Accounts ({count})',
  manageConnectedAccounts: 'Manage your connected email accounts',
  noAccountsConfigured: 'You have no email accounts configured',
  connectFirstAccountBtn: 'Connect first account',
  active: 'Active',
  inactive: 'Inactive',
  enabled: 'Enabled',
  disabled: 'Disabled',
  createdAgo: 'Created {time}',
  synchronize: 'Synchronize',
  activate: 'Activate',
  deactivate: 'Deactivate',
  delete: 'Delete',
  securityAndPrivacy: 'Security and Privacy',
  dataProtectionInfo: 'Information about how your data is protected',
  encryptedCredentials: 'Encrypted credentials',
  encryptedCredentialsDesc: 'Your passwords are stored encrypted with AES-256',
  secureConnections: 'Secure connections',
  secureConnectionsDesc: 'All IMAP/SMTP connections use SSL/TLS',
  limitedAccess: 'Limited access',
  limitedAccessDesc: 'Only you have access to your accounts and messages',
  deleteConfirm: 'Are you sure you want to delete this email account? All associated messages will be deleted.',

  // Account Setup
  backToProviderSelection: 'Back to Provider Selection',
  configureAccount: 'Configure {provider} Account',
  enterAccountDetails: 'Enter your account details to connect your email',
  gmailDetected: 'Gmail detected! Make sure to use your App Password (16 characters), not your regular password.',
  generateAppPassword: 'Generate App Password →',
  outlookDetected: 'Outlook detected! Make sure IMAP is enabled in your Outlook settings.',
  checkOutlookSettings: 'Check Outlook Settings →',
  yahooDetected: 'Yahoo detected! You need to use an App Password for third-party apps.',
  generateYahooAppPassword: 'Generate Yahoo App Password →',
  accountConfiguration: 'Account Configuration',
  credentialsSecure: 'Your credentials are encrypted and stored securely',
  emailAddress: 'Email Address',
  displayName: 'Display Name',
  displayNamePlaceholder: 'Your Name',
  appPassword: 'App Password',
  password: 'Password',
  appPasswordPlaceholder: '16-character App Password',
  passwordPlaceholder: 'Your email password',
  useAppPasswordNote: 'Use the App Password you generated, not your regular account password',
  serverConfiguration: 'Server Configuration',
  imapServer: 'IMAP Server',
  imapPort: 'IMAP Port',
  smtpServer: 'SMTP Server',
  smtpPort: 'SMTP Port',
  backToGuide: 'Back',
  connecting: 'Connecting...',
  connectAccount: 'Connect Account',
  securityPrivacy: 'Security & Privacy',
  securityPoint1: '• Your credentials are encrypted and stored securely in the database.',
  securityPoint2: '• Only you have access to your accounts and email messages.',
  securityPoint3: '• We recommend using App Passwords instead of your main account password.',
  securityPoint4: '• You can disconnect your account anytime from the settings.',

  // Reader
  selectMessage: 'Select a message to read',
  back: 'Back',
  markAsUnread: 'Mark as unread',
  download: 'Download',
  noSubject: '(No subject)',
  to: 'To',
  account: 'Account',
  attachments: 'attachments',
  loadingContent: 'Loading content...',
  noContent: 'No content',
  attachedFiles: 'Attached files',
  reply: 'Reply',
  replyAll: 'Reply all',
  forward: 'Forward',
  deleteConfirmMessage: 'Are you sure you want to delete this message?',
  
  // Module Page
  moduleTitle: 'Email Module',
  moduleDescription: 'Manage your email accounts from one place',
  viewMetrics: 'View Metrics',
  hideMetrics: 'Hide Metrics',
  totalMessagesShort: 'Total messages',
  unreadMessagesShort: 'Unread',
  activeAccountsShort: 'Active accounts',
  sentMessages: 'Sent',
  selectingAccount: 'Selecting account...',
  connectFirstEmailAccount: 'Connect your first email account',
  emailModuleDescription: 'To start using the email module, you need to connect at least one email account like Gmail, Outlook or a custom configuration.',
  emailReading: 'Email Reading',
  emailReadingDesc: 'Access your inbox and read your messages from a unified interface',
  emailSending: 'Email Sending',
  emailSendingDesc: 'Compose, reply and forward emails directly from the application',
  synchronizationShort: 'Synchronization',
  synchronizationShortDesc: 'Keep your messages synchronized automatically with the server',
  emailManagement: 'Email Management',
  syncAll: 'Sync All',
  newEmail: 'New Email',
  addAccount: 'Add Account',
  inboxTab: 'Inbox',
  sent: 'Sent',
  drafts: 'Drafts',
  spam: 'Spam',
  trash: 'Trash',
  folders: 'Folders',
  templates: 'Templates',
  accounts: 'Accounts',
  recommended: 'Recommended',
  functional: 'Functional',
  demoOnly: 'Demo only',

  // Inbox and Filters
  searchInAllFields: 'Search in all fields...',
  searchInEmails: 'Search in emails...',
  filters: 'Filters',
  advancedFilters: 'Advanced Filters',
  clearAll: 'Clear all',
  compose: 'Compose',
  unreadCount: '{count} unread',
  allFolders: 'All folders',
  onlyRead: 'Only read',
  onlyUnread: 'Only unread',
  allStatus: 'All',

  // Folder names
  inboxFolder: 'Inbox',
  sentFolder: 'Sent',
  draftsFolder: 'Drafts',
  spamFolder: 'Spam',
  trashFolder: 'Trash',
  
  // Status and sync
  connected: 'Connected',
  synchronized: 'Synchronized',
  syncStatus: 'Sync Status',
  notSynchronized: 'Not synchronized',
  syncButton: 'Sync',
  cacheManager: 'Cache Manager',
  messagesLoading: 'Loading messages...',
  noMessagesFound: 'No messages found',
  noMessagesAvailable: 'No messages available',
  loadMoreMessages: 'Load more messages'
};